export const defaultColors = {
    backgroundColor: "#ecf0f1",
    selectedBackgroundColor: "#2ecc71",
    fontColor: "#000",
    selectedFontColor: "#fff"
};
